import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { AppConsts } from "@shared/app-consts";
import { Observable, firstValueFrom } from "rxjs";
import { BaseService } from "./base.service";
import {
  AgendaRequest,
  AgendaTaskItemModel,
  AgendaTaskModel,
  CompanyAgendaModel,
} from "@shared/models/agenda";
import { map } from "rxjs/operators";
import { DateTimeService } from "./datetime.service";
import _ from "lodash";

@Injectable({
  providedIn: "root",
})
export class AgendaService extends BaseService {
  constructor(
    private http: HttpClient,
    private dateTimeService: DateTimeService
  ) {
    super();
  }
  getAgenda(request: AgendaRequest): Observable<CompanyAgendaModel> {
    let httpOptions = this.getHttpHeader(false, this.cleanEmpty(request));
    return (
      this.http.get(
        AppConsts.API_SERVICE_URL + `Agenda/getAgenda`,
        httpOptions
      ) as Observable<CompanyAgendaModel>
    ).pipe(map((x) => this._FillAgenda(x)));
  }

  downloadAgendaTaskItemFile(id: number) {
    let httpOptions = this.getHttpHeader(true);

    return firstValueFrom(this.http
      .get(AppConsts.API_SERVICE_URL + `Agenda/download/${id}`, httpOptions))
      .then((response: any) => {
        if (response) return this.getFileFromResponse(response);
        return null;
      });
  }

  _FillAgenda(model: CompanyAgendaModel): CompanyAgendaModel {
    return new CompanyAgendaModel({
      CompanyName: model.CompanyName,
      CompanyId: model.CompanyId,
      Tasks: this._FillAgendaEmptyMonths(model.Tasks),
    });
  }

  _FillAgendaEmptyMonths(items: AgendaTaskModel[]) {
    var result = items.map(
      (x) =>
        new AgendaTaskModel({
          Title: x.Title,
          Items: this._FillEmptyMonths(x.Items),
        })
    );

    return result;
  }

  _FillEmptyMonths(items: AgendaTaskItemModel[]): AgendaTaskItemModel[] {
    let months = this.dateTimeService.months();
    let itemsByMonth = _.keyBy(items, "Month");

    return months.map((x, index) => {
      if (itemsByMonth[index + 1]) return itemsByMonth[index + 1];
      return new AgendaTaskItemModel();
    });
  }
}
